import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => ({
  popper: {
    zIndex: "100001 !important",
  },
}));
